"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Date = {
    elemName: '日時',
    type: 'inline',
    doc: '日時情報をマークアップします。',
    example: '＜安政二年卯十月二日＞',
    minContentCount: 1,
    maxContentCount: 1,
    textTemplate: '{{$1}}',
    htmlTemplate: `<span {{{$htmlId}}} class="Date {{$classes}}">{{{$1}}}</span>`,
    xmlTemplate: `<date {{{$xmlId}}} {{{$xmlSubType}}}>{{{$1}}}</date>`,
    docxTemplate: `<w:r><w:rPr><w:rFonts w:hint="eastAsia"/></w:rPr><w:t>{{$$1}}</w:t></w:r>`,
    latexTemplate: '{{$text}}'
};
exports.default = Date;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRGF0ZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb252ZXJ0ZXIvaW5saW5lX3J1bGVzL0RhdGUudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFFQSxNQUFNLElBQUksR0FBbUI7SUFDNUIsUUFBUSxFQUFFLElBQUk7SUFDZCxJQUFJLEVBQUUsUUFBUTtJQUNkLEdBQUcsRUFBRSxpQkFBaUI7SUFDdEIsT0FBTyxFQUFFLGFBQWE7SUFDdEIsZUFBZSxFQUFFLENBQUM7SUFDbEIsZUFBZSxFQUFFLENBQUM7SUFDbEIsWUFBWSxFQUFFLFFBQVE7SUFDdEIsWUFBWSxFQUFFLCtEQUErRDtJQUM3RSxXQUFXLEVBQUUsc0RBQXNEO0lBQ25FLFlBQVksRUFBRSwyRUFBMkU7SUFDekYsYUFBYSxFQUFFLFdBQVc7Q0FDMUIsQ0FBQztBQUVGLGtCQUFlLElBQUksQ0FBQyJ9